import { registerFormInputComponent } from "@bb-vendure/admin-ui/core";
import { MultipleCurrencyFormInputComponent } from "./components/multiple-currency-form-input/multiple-currency-form-input.component";
import { CustomerListFormComponent } from "./components/customer-list-form-input/customer-list-form-input.component";
export default [
  registerFormInputComponent(
    'multiple-currency-form-input',
    MultipleCurrencyFormInputComponent
  ),

  registerFormInputComponent(
    "customer-list-form-input",
    CustomerListFormComponent
  ),
];
